import { BaseContainerModel } from '../../base-container.model';
import {
  bl_dgmkt_campaign_segment_link_RowClass,
  bl_dgmkt_campaign_segment_link_RowInterface,
} from '../../../dbschema/bl_dgmkt_campaign_segment_link.model';

export class DgMktCampaignSegmentContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_segment_link: bl_dgmkt_campaign_segment_link_RowInterface =
    new bl_dgmkt_campaign_segment_link_RowClass();
}
